import * as signalR from "@microsoft/signalr";

class SignalRService {
  constructor() {
    this.connection = null;
    this.isConnected = false;
    this.listeners = new Map();
    this.currentUserId = null;
  }

  async startConnection(userId) {
    if (!userId) return;

    if (this.connection && this.isConnected && this.currentUserId === userId) {
      console.log("SignalR connection already established");
      return;
    }

    if (this.connection && this.currentUserId !== userId) {
      await this.stopConnection();
    }

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}`;
    const hasToken = !!localStorage.getItem("token");
    const userQuery = !hasToken ? `?userId=${encodeURIComponent(userId)}` : "";

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiUrl}/hubs/notification${userQuery}`, {
        accessTokenFactory: () => {
          return localStorage.getItem("token") || "";
        }
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    try {
      await this.connection.start();
      this.isConnected = true;
      this.currentUserId = userId;
      console.log("SignalR Connected");

      // Setup notification listeners
      this.connection.on("ReceiveNotification", (notification) => {
        console.log("New notification received:", notification);
        this.notifyListeners("newNotification", notification);
      });

      this.connection.on("NotificationRead", (data) => {
        console.log("Notification marked as read:", data);
        this.notifyListeners("notificationRead", data);
      });

      this.connection.on("AllNotificationsRead", (data) => {
        console.log("All notifications marked as read:", data);
        this.notifyListeners("allNotificationsRead", data);
      });

    } catch (error) {
      console.error("SignalR Connection Error:", error);
      this.isConnected = false;
      this.currentUserId = null;
    }
  }

  async stopConnection() {
    if (this.connection) {
      try {
        await this.connection.stop();
        this.isConnected = false;
        this.currentUserId = null;
        console.log("SignalR Disconnected");
      } catch (error) {
        console.error("Error stopping SignalR connection:", error);
      }
    }
  }

  addListener(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  removeListener(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event).filter(cb => cb !== callback);
      this.listeners.set(event, callbacks);
    }
  }

  notifyListeners(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => callback(data));
    }
  }
}

export default new SignalRService();